<template>
  <div class="account-card" v-on:click="gotoAccount">
    <span class="user-name" :title="account.UserFriendlyName">{{
      account.UserFriendlyName
    }}</span>
    <span class="role">{{ getUserRole() }}</span>
    <hr />
    <span class="caption">Account</span>
    <span class="name" :title="account.AccountName">{{
      account.AccountName
    }}</span>
    <span class="select-button">
      <span class="arrow"></span>
    </span>
  </div>
</template>

<script type="ts">
import { Vue } from "vue-property-decorator";

export default Vue.extend({
  name: "AccountCard",
  props: ["account"],
  methods: {
    gotoAccount() {
      window.location = this.account.LoginUrl;
    },
    getUserRole() {
      return (this.account.UserRole == 1) ? 'Author' : 'Transcriptionist';
    }
  }
});
</script>

<style>
.account-card {
  display: inline-block;
  position: relative;
  cursor: pointer;
  background-color: white;
  border: 1px solid white;
  border-radius: 2px;
  margin: 8px;
  height: 254px;
  width: 218px;
  padding-left: 16px;
  padding-right: 16px;
  -webkit-box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.35);
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.35);
}
.account-card:hover {
  -webkit-box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.5);
}
.account-card > .user-name {
  font-family: "CentraleSansBold";
  font-size: 20px;
  line-height: 24px;
  margin-top: 47px;
  width: 218px;
  display: block;
  color: #1d4c84;
  overflow: hidden !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.account-card > .role {
  font-family: "CentraleSansBook";
  font-size: 14px;
  line-height: 20px;
  display: block;
  color: #37474f;
  opacity: 0.6;
}
hr {
  display: block;
  height: 1px;
  width: 20px;
  border: 0;
  border-top: 1px solid rgba(55, 71, 79, 0.16);
  margin: 16px 99px 16px 99px;
  padding: 0;
}
.account-card > .caption {
  font-family: "CentraleSansBook";
  font-size: 14px;
  line-height: 16px;
  display: block;
  color: #37474f;
  opacity: 0.6;
}
.account-card > .name {
  font-family: "CentraleSansBold";
  font-size: 14px;
  line-height: 20px;
  display: block;
  color: #37474f;
  opacity: 0.87;
  width: 218px;
  overflow: hidden !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select-button {
  position: absolute;
  bottom: 24px;
  display: inline-block;
  background-color: #41c9fe;
  height: 38px;
  width: 38px;
  line-height: 38px;
  border-radius: 2px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.arrow {
  background: url("//cdn.speech.com/assets/icons/arrow_forward_24px.svg");
  display: inline-block;
  margin: 7px;
  height: 24px;
  width: 24px;
}
</style>
